const WarehouseRoutes = [
    {
        path: '/warehouse',
        component: () => import('@/components/default'),
        children: [
            {
                path: '',
                name: 'warehouse',
                component: () => import('@/components/warehouse/WareHouse'),
            },
            {
                path: ':id?',
                name: 'warehouse-details',
                component: () =>
                    import('@/components/warehouse/WareHouseDetails'),
            },
            {
                path: ':id?/delivery/:locationId?',
                name: 'warehouse-details-lines',
                component: () => import('@/components/warehouse/DeliveryLines'),
            },
            {
                path: ':id?/transfer/:transferId?',
                name: 'warehouse-transfers-lines',
                component: () => import('@/components/warehouse/TransferLines'),
            },
        ],
    },
]

export default WarehouseRoutes